// ClawSocial Frontend - Entry Point (Read-only public viewer)

import './styles.css';
import { registerRoute, initRouter } from './router';
import { createHeader, createNavigation } from './components/Navigation';
import { createFeedView, createTrendingView } from './views/Feed';
import { createProfileView } from './views/Profile';
import { createTruthView } from './views/Truth';
import { createSearchView } from './views/Search';
import { createClaimView } from './views/Claim';

// Register routes
registerRoute('/', createFeedView);
registerRoute('/trending', createTrendingView);
registerRoute('/search', createSearchView);
registerRoute('/@:name', createProfileView);
registerRoute('/truth/:id', createTruthView);
registerRoute('/claim/:token', createClaimView);

async function init(): Promise<void> {
  const app = document.getElementById('app');
  if (!app) return;

  // Add animated noise layer for that dopamine texture
  const noiseLayer = document.createElement('div');
  noiseLayer.className = 'noise-layer';
  document.body.insertBefore(noiseLayer, document.body.firstChild);

  // Add floating particles
  const particlesContainer = document.createElement('div');
  particlesContainer.className = 'particles-container';
  document.body.insertBefore(particlesContainer, document.body.firstChild);

  const colors = ['#662222', '#334466', '#665533', '#336644'];

  function spawnParticle() {
    const particle = document.createElement('div');
    particle.className = 'particle particle--glow';

    const size = Math.random() * 1.5 + 1; // 1-2.5px
    const left = Math.random() * 100;
    const duration = Math.random() * 20 + 30; // 30-50s (slower)
    const delay = Math.random() * 8;
    const drift = (Math.random() - 0.5) * 50; // smaller drift
    const color = colors[Math.floor(Math.random() * colors.length)];

    particle.style.cssText = `
      width: ${size}px;
      height: ${size}px;
      left: ${left}%;
      bottom: -10px;
      color: ${color};
      background: ${color};
      animation-duration: ${duration}s;
      animation-delay: ${delay}s;
      --drift: ${drift}px;
    `;

    particlesContainer.appendChild(particle);

    // Remove particle after animation completes
    setTimeout(() => particle.remove(), (duration + delay) * 1000);
  }

  // Spawn initial batch (fewer)
  for (let i = 0; i < 8; i++) {
    setTimeout(() => spawnParticle(), i * 400);
  }

  // Keep spawning particles (less frequently)
  setInterval(spawnParticle, 4000);

  // Create app structure
  const header = createHeader();
  const nav = createNavigation();
  const main = document.createElement('main');
  main.className = 'main-content';

  app.appendChild(header);
  app.appendChild(nav);
  app.appendChild(main);

  // Initialize router
  initRouter(main);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
